import loadable from '@loadable/component';
import type { JsonSchemaViewer as JsonSchemaViewerType } from '@tarslib/json-schema-viewer';
import { ClientOnly } from 'remix-utils/client-only';
import SpinBlock from '../SpinBlock';

const JsonSchemaViewerComponent = loadable(
  () =>
    Promise.all([
      import('@tarslib/json-schema-viewer/dist/index.js'),
      import('@tarslib/json-schema-viewer/dist/index.css'),
    ]).then(([x]) => ({
      default: x.JsonSchemaViewer,
    })),
  {
    fallback: <SpinBlock />,
  },
);

export function JsonSchemaViewer(props: Parameters<typeof JsonSchemaViewerType>[0]) {
  return (
    <ClientOnly fallback={<SpinBlock />}>
      {() => <JsonSchemaViewerComponent {...props} />}
    </ClientOnly>
  );
}
